import { render, staticRenderFns } from "./AccountsReceivableReport.vue?vue&type=template&id=64774778&scoped=true"
import script from "./AccountsReceivableReport.vue?vue&type=script&lang=js"
export * from "./AccountsReceivableReport.vue?vue&type=script&lang=js"
import style0 from "./AccountsReceivableReport.vue?vue&type=style&index=0&id=64774778&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64774778",
  null
  
)

export default component.exports